export const colors = {
  white: "#f8f5f2",
  black: "#420808",
  primary: "#9f9540",
  primaryOld: "#9f9540",
  secondary: "#7a674e",
  titles: "#420808",
  font: "#420808",
  gray: "#efe3d8",
  inactive: "#eeece9", // subtle warm-neutral gray — disabled / collapsed-step / inactive surfaces (off-white, desaturated vs krem `gray`)
  linearGradient: "linear-gradient(345deg, rgba(136, 66, 46, 1) 0%, rgba(252, 199, 155, 1) 50%, rgba(136, 66, 46, 1) 100%)",
  secondary_opacity: "#e3c8a7",
  divider: "#d3a97f",
  primary_opacity: "#efe3d8",
  tatooPrimary: "#d29a28",
};

/** `#rrggbb` → `rgba(r, g, b, alpha)` — for tints derived from a palette colour (no extra hex tokens). */
export const alpha = (hex: string, value: number): string => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  return `rgba(${r}, ${g}, ${b}, ${value})`;
};
